import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { allEventVariables } from '@consts/alerts-v2.const';
import { TranslatePipe } from '@ngx-translate/core';
import { UiButtonComponent } from '@ui';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';

@Component({
  selector: 'input-dialog',
  imports: [
    MatDialogClose,
    TranslatePipe,
    UiButtonComponent,
    MonacoEditorModule,
    ReactiveFormsModule,
  ],
  templateUrl: './input-dialog.html',
  styleUrl: './input-dialog.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputDialog {
  constructor(
    private dialogRef: MatDialogRef<
      InputDialog,
      string
    >,
  ) { }

  protected editorOptions = signal({ language: 'json', automaticLayout: true });

  public message = new FormControl('');

  public close(): void {
    this.dialogRef.close();
  }

  public save(): void {
    this.dialogRef.close(this.message.value);
  }

  public onEditorInit(editor: any): void {
    const monaco = (window as any).monaco;
    setTimeout(() => {
      editor.getAction('editor.action.formatDocument')?.run();
    }, 500);

    if (!(window as any)?.jsonCompletionProviderRegistered) {
      monaco.languages.registerCompletionItemProvider('json', {
        provideCompletionItems: async (model, position) => {
          const textBeforeCursor = model.getValueInRange({
            startLineNumber: position.lineNumber,
            startColumn: 1,
            endLineNumber: position.lineNumber,
            endColumn: position.column,
          });

          if (!textBeforeCursor.endsWith('@')) {
            return { suggestions: [] };
          }

          const autoComplete = allEventVariables.map((variable) => {
            return {
              label: `@${variable}`,
              kind: monaco.languages.CompletionItemKind.Variable,
              insertText: `"{{${variable}}}"`,
            };
          });

          return {
            suggestions: autoComplete,
          };
        },
      });

      (window as any).jsonCompletionProviderRegistered = true;
    }
  }
}
